import { styled } from '@1kit/ui/theme'

export const PricingCardHeaderTextContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
`
